<template>
    <div class="pc-footer">
        <div class="footerBox">
            <!-- <div class="topFooter">
        <div class="minTop">
          <div class="topTitle">
            <i class="el-icon-phone"></i>
            全国免费咨询热线：
          </div>
          <div class="bottomTop">156-8080-6016</div>
        </div>
        <div class="minTop">
          <div class="topTitle">
            <i class="el-icon-location"></i>
            办公地址：
          </div>
          <div class="bottomTop" style="font-size: 14px">成都市金牛区大成仓·智汇园A205</div>
        </div>
         二维码未知 
        <div class="minqrcode"></div>
      </div> -->
            <div class="centerFooter">
                <span class="minNav" v-for="(v, i) in navList" :key="i" @click="toPage(v)">
                    {{ v.title }}
                </span>
            </div>
            <div class="bottomFooter">
                <span>版权所有：四川优墨科技有限公司</span>
                <span>
                    <span>备案编号：</span>
                    <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2022026325号-1</a>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            navList: [
                {
                    title: '首页',
                    url: '/',
                },
                {
                    title: '产品中心',
                    url: '/ecPlatform',
                },
                {
                    title: '合作案例',
                    url: '/alList',
                },
                {
                    title: '关于我们',
                    url: '/aboutUs',
                },
                {
                    title: '联系我们',
                    url: '/contactUs',
                },
            ],
        };
    },
    methods: {
        toPage(row) {
            this.$router.push(row.url);
        },
    },
};
</script>

<style lang="scss" scoped>
.pc-footer {
    width: 100%;
    background-color: #0c1836;
    .footerBox {
        width: 1264px;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 19px 32px;
        .topFooter {
            display: flex;
            justify-content: space-between;
            padding-bottom: 20px;
            border-bottom: 1px solid #999999;

            .minTop {
                .topTitle {
                    font-size: 14px;
                    color: #b3b3b3;
                }
                .bottomTop {
                    font-size: 24px;
                    color: #ffffff;
                    margin-top: 20px;
                    height: 30px;
                    line-height: 30px;
                }
            }
            .minqrcode {
                width: 110px;
                height: 110px;
                background-color: #fff;
            }
        }
        .centerFooter {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
            padding: 15px 10px;
            .minNav:last-child {
                border: none;
            }
            .minNav {
                padding: 0 15px;
                font-size: 14px;
                color: #b3b3b3;
                cursor: pointer;
                height: 20px;
                display: inline-block;
                border-right: 1px solid #b3b3b3;
            }
        }
        .bottomFooter {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 24px;
            font-size: 14px;
            color: #b3b3b3;
            a {
                color: #1e77ff;
            }
        }
    }
}
</style>
